/** @format */

import {Box, IconButton, Typography} from '@mui/material';
import {Theme} from '@mui/material/styles';
import {makeStyles, createStyles} from '@mui/styles';
import {useTranslation} from 'react-i18next';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

import AdTypePlatforms from 'components/icons/AdTypePlatforms';
import {YalperAdTypeWithStats} from 'types';

import {NotificationListFromQuery} from '../types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: '#202020',
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      marginTop: theme.spacing(4),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    actionButtonsContainer: {
      display: 'flex',
    },
    actionButton: {
      width: '48px',
      height: '48px',
      marginRight: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '8px',
      background: '#2B2B2B',
      '&:last-of-type': {
        marginRight: '0',
      },
      [theme.breakpoints.down('md')]: {
        flexGrow: '1',
      },
    },
    textNew: {
      color: '#FFF',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: 'normal',
      letterSpacing: '0.131px',
    },
    notificationChannelNew: {
      marginTop: theme.spacing(2),
      color: '#8B8B8B',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 'normal',
      letterSpacing: '0.131px',
    },
    rowNew: {
      marginTop: theme.spacing(4),
      padding: theme.spacing(4),
      borderRadius: '8px',
      background: '#2B2B2B',
      boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
      '&:first-of-type': {
        marginTop: 0,
      },
    },
  }),
);

interface Props {
  notification: NotificationListFromQuery;
  onEdit: () => void;
  onDelete: () => void;
}

const Row = (props: Props) => {
  const classes = useStyles();

  const {t} = useTranslation();

  const channelName = () => {
    if (props.notification.channelType === 'TELEGRAM') {
      return 'Бот в Телеграме';
    }
    return props.notification.emailChannel.email;
  };

  const text = (adType: YalperAdTypeWithStats) => {
    if (adType === 'CONTEXT') return t('Контекст', 'Контекст');
    if (adType === 'TARGET') return t('Таргет', 'Таргет');

    return null;
  };

  return (
    <Box className={classes.container}>
      <Box display='flex' justifyContent='space-between'>
        <Box>
          <Typography className={classes.textNew}>{props.notification.company.name}</Typography>
          <Typography className={classes.notificationChannelNew}>{channelName()}</Typography>
        </Box>

        <Box className={classes.actionButtonsContainer}>
          <IconButton
            className={classes.actionButton}
            aria-label='edit-notification-button'
            onClick={props.onEdit}
            size='large'
          >
            <EditOutlinedIcon htmlColor='#fff' fontSize='small' />
          </IconButton>
          <IconButton
            className={classes.actionButton}
            aria-label='delete-notification-button'
            onClick={props.onDelete}
            size='large'
          >
            <DeleteForeverOutlinedIcon htmlColor='#fff' fontSize='small' />
          </IconButton>
        </Box>
      </Box>

      {props.notification.adTypes.map((v, i) => (
        <Box key={i} className={classes.rowNew}>
          <Box display='flex' flexGrow={1} justifyContent='space-between' alignItems='center'>
            {text(v)}
            <AdTypePlatforms adTypes={[v]} size={20} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default Row;
